// extracted by mini-css-extract-plugin
export var container = "PressAndSupporterList-module--container--L5sJb";
export var link = "PressAndSupporterList-module--link--wuvV9";
export var title = "PressAndSupporterList-module--title--QSpGK";